import $ from 'jquery';
import { smoothscroll } from '../utils/smoothscroll';
import { flipSign } from '../utils/functions';

const $faqListEl = $('.faq-list');

$(function () {
    if ($faqListEl.length > 0) {
        $faqListEl.each(function () {
            const $thisEl = $(this);
            faqList($thisEl);
        });
    }
});

const faqList = (listEl) => {
    const filter = {
        categories: listEl.data('categories'),
        category: -1,
        lang: $faqListEl.data('lang'),
    };

    addColors(listEl);
    bindfaqFilter(listEl, filter);
    bindToggleFaqs(listEl);
};

const addColors = (element) => {
    const $options = element.find('.button-filter__option');

    if ($options.length > 0) {
        $options.each(function () {
            const $thisEl = $(this);
            const color = $thisEl.data('color');
            const faqId = $thisEl.data('value');

            const $card = element.find('.faq-card__heading[data-faqid="' + faqId + '"]').closest('.faq-card');
            $card.addClass('color-' + color);
        });
    } else {
        element.find('.faq-card').addClass('color-1');
    }
};

const bindToggleFaqs = (element) => {
    element.on('click', '.faq__trigger', function () {
        const $thisEl = $(this);
        const $faq = $thisEl.closest('.faq');
        const $faqContentWrapper = $faq.find('.faq__content-wrapper');

        if ($faqContentWrapper.is(':hidden')) {
            $faqContentWrapper.slideDown(300);
            $faq.addClass('active');
        } else {
            $faqContentWrapper.slideUp(500, function () {
                $faq.removeClass('active');
            });
        }

        const scrollPos = $faq.closest('.faq-card');
        const offset = flipSign($faq.position().top - 20);
        smoothscroll(scrollPos, offset);
    });
};

const reRenderList = async (element, filter, scrollTop = false) => {
    const data = await getFaqs(filter);
    element.find('.faq-list__content').html(data.html);
    addColors(element);

    if (scrollTop === true) {
        smoothscroll($faqListEl);
    }
};

const bindfaqFilter = (element, filter) => {
    element.on('click', '.button-filter__option', function () {
        const $thisEl = $(this);
        element.find('.button-filter__option.active').removeClass('active');
        $thisEl.addClass('active');
        element.find('.button-filter__reset').addClass('active');

        filter.category = $thisEl.data('value');
        reRenderList(element, filter);
    });

    element.on('click', "button[name='remove-faq-filter']", function () {
        element.find('.button-filter__option.active').removeClass('active');
        element.find('.button-filter__reset').removeClass('active');

        filter.category = -1;

        reRenderList(element, filter);
    });
};

const getFaqs = async (filter) => {
    try {
        const response = await fetch(SITE_PARAMS.site_url + '/wp-json/kvop/v1/faq-list/html', {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            body: JSON.stringify(filter),
        });
        const result = await response.json();
        return result;
    } catch (e) {
        console.log(e);
        return null;
    }
};
